document.addEventListener("DOMContentLoaded", () => {
  const checkboxs = document.querySelectorAll(".show_swatches");

  if (!checkboxs.length) {
    return;
  }

  window.toggleSwatches = () => {
    const swatchImages = document.querySelectorAll(".product-card-swiper");
    let showSwatches = document.querySelector(".show_swatches").checked;

    swatchImages.forEach((swatchImage) => {
      const swiperInstance = swatchImage.swiper;
      if (swiperInstance) {
        swiperInstance.slideTo(showSwatches ? 0 : 1);
      }
    });
  };

  checkboxs.forEach((el) => el.addEventListener("change", toggleSwatches));
  window.toggleSwatches();
});
